<template>
  <v-container fluid grid-list-lg>
    <v-card>
      <v-toolbar>
        <v-icon>ballot</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Importación de Archivos de Débitos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text>
        <v-row dense>
          <v-col>
            <v-autocomplete
              v-model="empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="formatoEnvioId"
              :items="formatosEnvio"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Archivo de"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="cajaId"
              :items="cajasEmpresa"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Imputar En"
              placeholder="Seleccione un Caja en dónde imputar"
            ></v-autocomplete>
          </v-col>
          <!-- <v-col>
                    <v-autocomplete v-model="bancoId" :items="bancos" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="Fondos Depositados en"></v-autocomplete>
                    </v-col> -->
        </v-row>
        <v-row align="center" dense>
          <v-col>
            <v-file-input
              v-model="archivosASubir"
              dense
              placeholder="Seleccione el Archivo a Procesar"
              label="Archivo a Procesar"
              @change="recordsPreProceso = []"
              counter
              show-size
              prepend-icon="mdi-paperclip"
            >
            </v-file-input>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              label="Generado en Smart"
              v-model="generadoEnSmart"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              label="Sólo Punitorios"
              v-model="soloPunitorios"
              v-if="generadoEnSmart"
            ></v-checkbox>
          </v-col>
          <v-col cols="4" lg="2" v-if="archivosASubir && (formatoEnvioId == 1000 || formatoEnvioId == 1002)">
            <v-btn
              :disabled="loading"
              text
              class="black--text green"
              @click.native="dividirArchivo"
              small
            >
              Dividir Archivo &nbsp;
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="20"
              ></v-progress-circular>
            </v-btn>
          </v-col>
          <v-col cols="4" lg="2" v-if="archivosASubir">
            <v-btn
              :disabled="loading"
              text
              class="black--text green"
              @click.native="preProcesarArchivo"
              small
            >
              Pre-Procesar &nbsp;
              <v-progress-circular
                v-if="loading"
                indeterminate
                size="20"
              ></v-progress-circular>
            </v-btn>

            <!-- <v-btn text dark class="green" @click="wea"  >
                             Try
                          </v-btn> -->
          </v-col>
        </v-row>
        <v-row align="center" dense v-if="formatoEnvioId == 22">
          <v-chip label dark color="orange"
            >El archivo debe tener formato Excel, con las siguientes columnas:
            F.IMPACTO, IMPORTE, RESULTADO, NOMBRE, DOCUMENTO, REFERENCIA</v-chip
          >
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              dense
              :headers="headersPreProceso"
              :items="recordsPreProceso"
              :rows-per-page="pagination.itemsPerPage"
              :options.sync="pagination"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption"></td>
                  <td class="text-xs-left caption">
                    <tr>
                      {{
                        item.infoPersona
                      }}
                    </tr>
                    <tr>
                      {{
                        item.infoDeuda ? item.infoDeuda : ''
                      }}
                    </tr>
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.importe | currency }}
                  </td>
                  <td class="text-xs-left caption">{{ item.resultado }}</td>
                  <td class="text-xs-left caption">
                    {{ item.imputacionDescripcion }}
                  </td>
                  <td class="text-xs-left caption">{{ item.errores }}</td>
                  <td class="text-xs-left caption">{{ item.referenciaId }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row dense v-if="recordsPreProceso.length > 0">
          <v-col cols="6" lg="4">
            {{ totalPagosAImputar }}
          </v-col>
          <v-col cols="6" lg="3">
            {{ totalPagosRechazados }}
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="6" lg="3">
            <v-btn
              small
              color="success"
              @click="agregarLote()"
              :disabled="loading"
            >
              Agregar a Lotes a Procesar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-row><v-col></v-col></v-row>

    <v-expansion-panels
      v-model="importacionCardCred"
      v-if="formatoEnvioId == 1001"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-toolbar>
            <v-icon>ballot</v-icon>
            <v-toolbar-title class="font-weight-light"
              >&nbsp;Importación de Lotes CardCred</v-toolbar-title
            >
          </v-toolbar>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-autocomplete
                    v-model="empresaId"
                    :items="empresas"
                    autocomplete="disabled"
                    item-text="nombre"
                    item-value="id"
                    label="Créditos de la Empresa"
                    placeholder="Seleccione una"
                    :menu-props="{ minWidth: '400' }"
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="cajaId"
                    :items="cajasEmpresa"
                    autocomplete="disabled"
                    item-text="descripcion"
                    item-value="id"
                    label="Imputar En"
                    placeholder="Seleccione un Caja en dónde imputar"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col>
                    <v-autocomplete v-model="bancoId" :items="bancos" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="Fondos Depositados en"></v-autocomplete>
                    </v-col> -->
              </v-row>

              <v-row align="center" dense>
                <v-col cols="4" lg="2"> Pagos realizados </v-col>
                <v-col cols="4" lg="2">
                  <v-text-field
                    v-model="filtroCardCredDocumento"
                    label="Documento"
                    hint="Completar para buscar un caso puntual"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" lg="2">
                  <app-selector-periodos
                    row
                    v-on:update-periodo="periodoPagosCardcred = $event"
                  >
                  </app-selector-periodos>
                </v-col>
                <v-col cols="4" lg="2">
                  <v-btn
                    :disabled="loading"
                    text
                    class="black--text green"
                    @click.native="buscarPagosCardcred"
                    small
                  >
                    Buscar Pagos a Procesar &nbsp;
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      size="20"
                    ></v-progress-circular>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    dense
                    :headers="headersPreProceso"
                    :items="recordsPreProceso"
                    :rows-per-page="pagination.itemsPerPage"
                    :options.sync="pagination"
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="text-xs-left caption"></td>
                        <td class="text-xs-left caption">
                          <tr>
                            {{
                              item.infoPersona
                            }}
                          </tr>
                          <tr>
                            {{
                              item.infoDeuda ? item.infoDeuda : ''
                            }}
                          </tr>
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.importe | currency }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.resultado }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.imputacionDescripcion }}
                        </td>
                        <td class="text-xs-left caption">{{ item.errores }}</td>
                        <td class="text-xs-left caption">
                          {{ item.referenciaId }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-data-table
                    dense
                    :headers="headersLotesCardCred"
                    :items="recordsLotesCardCred"
                    :rows-per-page="pagination.itemsPerPage"
                    :options.sync="paginationLotesCardCred"
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td
                          class="text-xs-left caption"
                          @click="verDetalleLoteCardCred(item.id)"
                        >
                          <v-btn x-small>Detalle</v-btn>
                        </td>
                        <td class="text-xs-left caption">
                          {{
                            item.fecha
                              | dateParse()
                              | dateFormat('DD-MM-YY HH:mm')
                          }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.responsable }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.importeTotal | currency }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.loteCardcred }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.cantidadRegistros }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-row dense v-if="recordsPreProceso.length > 0">
                <v-col cols="6" lg="4">
                  {{ totalPagosAImputar }}
                </v-col>
                <v-col cols="6" lg="3">
                  {{ totalPagosRechazados }}
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" lg="3">
                  <v-btn
                    small
                    color="success"
                    @click="agregarLote()"
                    :disabled="loading"
                  >
                    Agregar a Lotes a Procesar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row><v-col></v-col></v-row>

    <v-card>
      <v-toolbar>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Lotes a Procesar</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="4">
            <v-autocomplete
              v-model="empresaLoteAProcesarId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Lotes a Procesar de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>

          <v-btn small color="indigo" dark @click="loadLotesAProcesar"
            >Cargar</v-btn
          >
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              dense
              :headers="headersAProcesar"
              :items="recordsAProcesar"
              :rows-per-page="paginationAProcesar.itemsPerPage"
              :options.sync="paginationAProcesar"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">
                    {{ item.formatoArchivoDescripcion }}
                  </td>
                  <td class="text-xs-left caption">
                    {{
                      item.fecha | dateParse() | dateFormat('DD-MM-YY HH:mm')
                    }}
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.cajaDescripcion }}
                  </td>
                  <td class="text-xs-left caption">{{ item.fileName }}</td>
                  <td class="text-xs-left caption">
                    <tr>
                      A Imputar:
                      {{
                        item.cantidadRegistrosAImputar
                      }}
                    </tr>
                    <tr v-if="item.registrosProcesados > 0">
                      Procesados:
                      {{
                        item.registrosProcesados
                      }}
                    </tr>
                    <tr>
                      A Imputar Manual:
                      {{
                        item.cantidadRegistrosAImputarManual
                      }}
                    </tr>
                    <tr>
                      Rechazados:
                      {{
                        item.cantidadRegistrosRechazados
                      }}
                    </tr>
                  </td>
                  <td class="text-xs-left caption">
                    <tr>
                      A Imputar:
                      {{
                        item.importeTotalAImputar | currency
                      }}
                    </tr>
                    <tr>
                      A Imputar Manual:
                      {{
                        item.importeTotalAImputarManual | currency
                      }}
                    </tr>
                    <tr>
                      Rechazados:
                      {{
                        item.importeTotalRechazado | currency
                      }}
                    </tr>
                  </td>

                  <td class="text-xs-left caption">
                    {{
                      item.registrosProcesados == 0
                        ? 'Pendiente'
                        : 'Proceso Parcial'
                    }}
                  </td>

                  <td class="text-xs-left">
                    <!-- <v-icon small class="mr-2" @click="verLote(item)" >edit</v-icon> -->
                    <v-btn
                      dark
                      x-small
                      color="green"
                      @click="procesarLotes(item)"
                      >Procesar</v-btn
                    >
                    <v-btn
                      dark
                      x-small
                      color="red"
                      @click="deleteLote(item)"
                      v-if="item.registrosProcesados == 0"
                      >Eliminar</v-btn
                    >
                    <v-btn
                      dark
                      x-small
                      color="red"
                      @click="pasarLoteACompletado(item)"
                      v-if="item.registrosProcesados > 0"
                      >Pasar a Completado</v-btn
                    >
                    <v-btn
                      dark
                      x-small
                      color="red"
                      @click="anularLote(item)"
                      v-else
                      >Anular</v-btn
                    >
                    <!-- <v-icon small color="red"  @click="deleteLote(item)">delete</v-icon> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="recordsAProcesar.length > 0">
        <v-row dense align="center">
          <v-col>
            <v-checkbox
              label="Enviar SMS x Rechazo"
              v-model="enviarSmsRechazo"
            ></v-checkbox>
          </v-col>
          <v-col v-if="enviarSmsRechazo">
            <v-autocomplete
              v-model="modeloSMSRechazoId"
              :items="listModelosSMS"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Modelo de SMS"
            ></v-autocomplete>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-checkbox
              label="Solicitar Aut. AFIP"
              v-model="solicitarAutorizacionAfip"
            ></v-checkbox>
          </v-col>
          <v-col> </v-col>
        </v-row>
        <v-row dense align="center">
          <v-col>
            <v-checkbox
              label="Enviar SMS x Débito"
              v-model="enviarSmsDebito"
            ></v-checkbox>
          </v-col>
          <v-col v-if="enviarSmsDebito">
            <v-autocomplete
              v-model="modeloSMSDebitoId"
              :items="listModelosSMS"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Modelo de SMS"
            ></v-autocomplete>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-checkbox
              label="Generar Contacto"
              v-model="generarContacto"
            ></v-checkbox>
          </v-col>
          <v-col>
            <!-- <v-btn @click="procesarLotes()" color="info"
              >Procesar {{ recordsAProcesar.length }} Lote{{
                recordsAProcesar.length > 1 ? 's' : ''
              }}
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row dense>
          <v-col>
            <v-btn dark color="brown" @click="showHistorial = true">
              Ver Historial de Proceso&nbsp;
              <v-icon>date_range</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <!-- process progress -->
    <v-dialog v-model="showProcesoProgress" max-width="800" persistent>
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Proceso de Lotes de Débitos...</v-card-title
        >
        <v-card-text>
          <v-container fluid v-if="loteProcesoActual != null">
            <v-row dense>
              <v-col>
                Procesando Lote Nº {{ loteProcesoActual.lote }} de
                {{ loteProcesoActual.formatoArchivoDescripcion }} ...
              </v-col>
              <v-col>
                <v-progress-circular
                  v-if="loteProcesoActual.statusProceso == -1"
                  indeterminate
                  color="red"
                ></v-progress-circular>
                <v-icon large v-if="loteProcesoActual.statusProceso == 1"
                  >done</v-icon
                >
                <v-icon large v-if="loteProcesoActual.statusProceso == 2"
                  >error</v-icon
                >
                <v-icon
                  large
                  v-if="loteProcesoActual.statusProceso == 0"
                ></v-icon>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                {{ loteProcesoActual.mensaje }}
              </v-col>
            </v-row>
          </v-container>

          <template v-for="(item, index) in lotesProcesados">
            <v-container fluid :key="index">
              <v-row dense>
                <v-col>
                  Proceso Finalizado de Lote Nº {{ item.lote }} de
                  {{ item.formatoArchivoDescripcion }} ...
                </v-col>
                <v-col>
                  <v-icon large v-if="item.statusProceso == 1">done</v-icon>
                  <v-icon large v-if="item.statusProceso == 2">error</v-icon>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  {{ item.mensaje }}
                </v-col>
                <v-col>
                  <v-btn
                    dark
                    x-small
                    color="info"
                    @click="imprimirRespaldatorio(item)"
                  >
                    Imprimir Respaldatorios
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="showProcesoProgress = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showHistorial"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Historial de Envíos Realizados</v-card-title
        >
        <v-card-text>
          <v-row dense>
            <v-col cols>
              <v-autocomplete
                v-model="formatoId"
                :items="formatoEnvio"
                autocomplete="disabled"
                item-text="descripcion"
                item-value="id"
                label="Archivo de"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <app-selector-periodos
                row
                v-on:update-periodo="periodoLote = $event"
              ></app-selector-periodos>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn dark color="blue" @click="loadHistorialLotes">
              Consultar&nbsp;
            </v-btn>
          </v-row>

          <!-- <v-flex right>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar por Nombre"
                    single-line
                    hide-details
                ></v-text-field>
              </v-flex> -->

          <v-data-table
            dense
            :headers="headersLog"
            :items="recordsLog"
            :server-items-length="totalItemsLog"
            :loading="loadingLog"
            :options.sync="optionsLog"
            :footer-props="{ itemsPerPageOptions: optionsLog.rowsPerPageItems }"
          >
            <template slot="no-data">
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron datos
              </v-alert>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  {{ item.formatoArchivoDescripcion }}
                </td>
                <td class="text-xs-left caption">{{ item.cajaDescripcion }}</td>
                <td class="text-xs-left caption">{{ item.fileName }}</td>
                <td class="text-xs-left caption">
                  <tr>
                    Debitados:
                    {{
                      item.cantidadRegistrosAImputar +
                      item.cantidadRegistrosAImputarManual
                    }}
                    por
                    {{
                      (item.importeTotalAImputar +
                        item.importeTotalAImputarManual)
                        | currency
                    }}
                  </tr>
                  <tr>
                    Rechazados:
                    {{
                      item.cantidadRegistrosRechazados
                    }}
                    por
                    {{
                      item.importeTotalRechazado | currency
                    }}
                  </tr>
                </td>

                <td class="text-xs-left caption">
                  <v-chip small color="red" dark v-if="item.anulado"
                    >Anulado por {{ item.responsableAnulacion }} el
                    {{
                      item.fechaAnulacion
                        | dateParse()
                        | dateFormat('DD-MM-YY HH:mm')
                    }}</v-chip
                  >
                  <span
                    v-if="
                      !item.anulado &&
                      item.registrosProcesados == item.registros
                    "
                    >Procesado el
                    {{
                      item.fechaProceso
                        | dateParse()
                        | dateFormat('DD-MM-YY HH:mm')
                    }}
                  </span>
                  <span
                    v-if="
                      !item.anulado &&
                      item.registrosProcesados != item.registros
                    "
                    >Sin Procesar
                  </span>
                </td>

                <td class="text-xs-left">
                  <!-- <v-icon small class="mr-2" @click="verLote(item)" >edit</v-icon> -->
                  <v-btn
                    dark
                    x-small
                    color="red"
                    @click="anularLote(item)"
                    v-if="item.registrosProcesados > 0 && !item.anulado"
                    >Anular Proceso</v-btn
                  >

                  <v-btn
                    dark
                    x-small
                    color="info"
                    @click="imprimirRespaldatorio(item)"
                    v-if="item.registrosProcesados > 0 && !item.anulado"
                  >
                    Imprimir Respaldatorios
                  </v-btn>
                  <!-- <v-icon small color="red"  @click="deleteLote(item)">delete</v-icon> -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text dark class="green" @click.native="showHistorial = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showStatusLoteCardcred"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Estado de Lote Enviado </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="headersStatusLote"
            :items="recordsStatusLote"
            :server-items-length="totalItemsStatusLote"
            :loading="loadingStatusLote"
            :options.sync="optionsStatusLote"
            :footer-props="{
              itemsPerPageOptions: optionsStatusLote.rowsPerPageItems,
            }"
          >
            <template slot="no-data">
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron datos
              </v-alert>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  {{ item.importe | currency }}
                </td>
                <td class="text-xs-left caption">{{ item.inicioBarrido }}</td>
                <td class="text-xs-left caption">
                  {{ item.operacionCardcred }}
                </td>
                <td class="text-xs-left caption">{{ item.personaNombre }}</td>
                <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
                <td class="text-xs-left caption">{{ item.resultado }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            dark
            class="green"
            @click.native="showStatusLoteCardcred = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showCobranzasCardcred"
      scrollable
      persistent
      :overlay="false"
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Estado de Lote Enviado </v-card-title>

        <v-card-text>
          <v-data-table
            dense
            :headers="headersCobranzasCardcred"
            :items="recordsStatusLote"
            :server-items-length="totalItemsStatusLote"
            :loading="loadingStatusLote"
            :options.sync="optionsStatusLote"
            :footer-props="{
              itemsPerPageOptions: optionsStatusLote.rowsPerPageItems,
            }"
          >
            <template slot="no-data">
              <v-alert :value="true" color="grey" icon="warning">
                No se encontraron datos
              </v-alert>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">{{ item.personaNombre }}</td>
                <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
                <td class="text-xs-left caption">
                  {{ item.importe | currency }}
                </td>
                <td class="text-xs-left caption">
                  {{ item.aplicarACuota | currency }}
                </td>
                <td class="text-xs-left caption">
                  {{
                    (item.aplicarAPunitorios + item.aplicarACargos) | currency
                  }}
                </td>

                <td class="text-xs-left caption">
                  {{ item.personaDocumento }}
                </td>
                <td class="text-xs-left caption">{{ item.transaccion }}</td>
                <td class="text-xs-left caption">{{ item.loteCardCred }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            dark
            class="green"
            @click.native="showCobranzasCardcred = false"
          >
            Cerrar
          </v-btn>
          <v-spacer />
          <v-btn
            text
            dark
            class="green"
            @click.native="agregarCobranzasCardcred"
          >
            Agregar a Lotes a Procesar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-loading :loading="loading || loadingStatusLote"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{}}
      <p></p>
    </template>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import { Decimal } from 'decimal.js';

import { http } from '@/axios';
import Vue from 'vue';
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
import { format } from 'date-fns';

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      records: [], // registros
      headersLog: [
        // definición de columnas
        { text: 'Origen', value: 'origen' },
        { text: 'Imputado en', value: 'imputarEn' },
        { text: 'Archivo', value: 'fileName' },
        {
          text: 'Registros',
          value: 'cantidadRegistros',
          sortable: false,
          width: 200,
        },
        {
          text: 'Estado Lote',
          value: 'estadoLote',
          sortable: false,
          width: 200,
        },
        { text: 'Acciones', value: 'name', sortable: false },
      ],
      headersAProcesar: [
        // definición de columnas
        { text: 'Origen', value: 'origen' },
        { text: 'Agregado el', value: 'fecha' },
        { text: 'Imputar En', value: 'imputarEn' },
        { text: 'Archivo', value: 'fileName' },
        { text: '# Registros', value: 'cantidadRegistros', sortable: false },
        { text: '$ Importes', value: 'importeTotal', sortable: false },
        { text: 'Estado Lote', value: 'estadoLote', sortable: false },
        { text: 'Acciones', value: 'name', sortable: false },
      ],
      headersPreProceso: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 60, sortable: false },
        { text: 'Débito a', value: 'infoPersona' },
        { text: 'Importe', value: 'importeDebitado', width: 110 },
        { text: 'Resultado', value: 'resultado' },
        { text: 'Imputación', value: 'imputacionDescripcion' },
        { text: 'Errores', value: 'errores' },
        { text: 'Nº Referencia', value: 'referenciaId', width: 110 },
      ],
      headersLotesCardCred: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 60, sortable: false },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Responasble', value: 'responsable' },
        { text: 'Importe', value: 'importeTotal', width: 110 },
        { text: 'LoteCardcred', value: 'loteCardcred' },
        { text: 'Cantidad Ops.', value: 'cantidadRegistros' },
      ],
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      paginationAProcesar: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      paginationLotesCardCred: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50, 1000],
      },
      recordsPreProceso: [],
      recordsAProcesar: [],
      recordsLotesCardCred: [],
      recordsLog: [],
      totalItemsLog: 0,
      totalItemsLotesCardCred: 0,
      optionsLog: {
        // definición de paginación
        sortDesc: [true],
        sortBy: ['lote'],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      loadingLog: false,
      showHistorial: false,
      empresas: [],
      cajas: [],
      bancos: [],
      formatosEnvio: [],
      formatoEnvio: [],
      formatoEnvioId: 0,
      formatoId: 0,
      periodoLote: { id: 1 },
      listModelosSMS: [],
      modeloSMSRechazoId: 0,
      modeloSMSDebitoId: 0,
      bancoId: 0,
      cajaId: 0,
      empresaId: 0,
      empresaLoteAProcesarId: 0,
      archivosASubir: null,
      resultadoPreProceso: null,
      enviarSmsRechazo: false,
      enviarSmsDebito: false,
      solicitarAutorizacionAfip: false,
      generarContacto: false,
      showProcesoProgress: false,
      lotesAProcesar: [],
      lotesProcesados: [],
      loteProcesoActual: null,
      importacionCardCred: false,
      generadoEnSmart: false,
      soloPunitorios: false,
      filtroCardCredDocumento: '',
      showStatusLoteCardcred: false,
      showCobranzasCardcred: false,
      headersStatusLote: [
        // definición de columnas
        // { text: 'Ver', value: 'accion', width:60, sortable:false },
        { text: 'Importe', value: 'importe' },
        { text: 'Inicio Barrido', value: 'inicioBarrido' },
        { text: 'Op. Cardcred', value: 'operacionCardcred' },
        { text: 'Persona', value: 'personaNombre' },
        { text: 'Nº Crédito', value: 'numeroCredito', width: 110 },
        { text: 'Tx Cardcred', value: 'transaccion' },
        { text: 'Resultado', value: 'resultado' },
      ],
      headersCobranzasCardcred: [
        // definición de columnas
        // { text: 'Ver', value: 'accion', width:60, sortable:false },
        { text: 'Persona', value: 'personaNombre' },
        { text: 'Nº Crédito', value: 'numeroCredito' },
        { text: '$ Total', value: 'importe', width: 100 },
        { text: '$ Cuota', value: 'aplicarACuota', width: 100 },
        { text: '$ Punit.', value: 'aplicarAPunitorios', width: 100 },
        { text: 'Documento', value: 'documento' },
        { text: 'Tx Cardcred', value: 'transaccion' },
        { text: 'Lote', value: 'loteCardCred' },
      ],
      recordsStatusLote: [],
      totalItemsStatusLote: 0,
      loadingStatusLote: false,
      optionsStatusLote: {
        // definición de paginación
        sortDesc: [true],
        sortBy: ['lote'],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      periodoPagosCardcred: { id: 1 },
    };
  },
  async created() {
    this.loadBancos();
    this.loadCajas();
    this.loadEmpresas();
    this.loadFormatosEnvio();
    this.loadFormatoEnvio();

    if (this.ParametrosGenerales.conexionSms) {
      await this.loadModelosSMS();
      this.enviarSmsRechazo = this.ParametrosGenerales.smsRechazoDebito;
      this.modeloSMSRechazoId =
        this.ParametrosGenerales.smsModelRechazoDebitoId;
    }
  },
  watch: {
    optionsLog: {
      handler() {
        this.loadHistorialLotes();
      },
      deep: true,
    },
    paginationAProcesar: {
      handler() {
        this.loadLotesAProcesar();
      },
      deep: true,
    },
    showHistorial() {
      // if(this.showHistorial){
      //   this.loadHistorialLotes();
      // }
    },
    importacionCardCred() {
      if (this.importacionCardCred == 0) {
        this.loadLotesCardCred();
      }
    },
  },
  computed: {
    ...mapGetters([
      'getActionFromLink',
      'error',
      'user',
      'ParametrosGenerales',
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    totalPagosAImputar: function () {
      var cantidad = 0;
      var importe = 0;
      for (let index = 0; index < this.recordsPreProceso.length; index++) {
        const item = this.recordsPreProceso[index];
        if (item.resultado == 'Debitado') {
          cantidad++;
          importe = new Decimal(importe).plus(item.importe);
        }
      }
      return cantidad + ' Debitos' + ', por $ ' + importe.toFixed(2);
    },
    totalPagosRechazados: function () {
      var cantidad = 0;
      var importe = 0;
      for (let index = 0; index < this.recordsPreProceso.length; index++) {
        const item = this.recordsPreProceso[index];
        if (item.resultado == 'Rechazado') {
          cantidad++;
          importe = new Decimal(importe).plus(item.importe);
        }
      }
      return cantidad + ' Rechazos';
    },
    // eslint-disable-next-line vue/return-in-computed-property
    cajasEmpresa: function () {
      var empresaSelected = this.empresas.filter(
        (e) => e.id == this.empresaId
      )[0];
      var formatoSelected = this.formatosEnvio.filter(
        (f) => f.id == this.formatoEnvioId
      )[0];

      if (empresaSelected != null && formatoSelected != null) {
        var cajaAsociadaArgen = empresaSelected.parametrosDebitos.find(
          (e) =>
            e.formatoId == formatoSelected.id ||
            (formatoSelected.id == 1005 && e.formatoId == 1001)
        ).cajaAsociadaArgenId;

        var cajaAsociadaFinadi = empresaSelected.parametrosDebitos.find(
          (e) =>
            e.formatoId == formatoSelected.id ||
            (formatoSelected.id == 1005 && e.formatoId == 1001)
        ).cajaAsociadaFinadiId;

        if (cajaAsociadaArgen != null && this.empresaId == 1) {
          return this.cajas.filter((c) => c.id == cajaAsociadaArgen);
        } else if (cajaAsociadaFinadi != null && this.empresaId == 2) {
          return this.cajas.filter((c) => c.id == cajaAsociadaFinadi);
        } else {
          return this.cajas.filter((c) => c.empresaId == this.empresaId);
        }
      }

      // if(formatoSelected != null){

      //     if(formatoSelected.cajaAsociadaArgenId != null && this.empresaId == 1){
      //         return this.cajas.filter(c=>c.id == formatoSelected.cajaAsociadaArgenId);
      //     }else if(formatoSelected.cajaAsociadaFinadiId != null && this.empresaId == 2){
      //        return this.cajas.filter(c=>c.id == formatoSelected.cajaAsociadaFinadiId);
      //     }else{
      //       return this.cajas.filter(c=>c.empresaId == this.empresaId);
      //     }
      // }
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),

    async agregarLote() {
      if (this.archivosASubir == null) {
        this.alertWarning(
          'Por favor, seleccione el a procesar antes de Agregar el Lote'
        );
        return;
      }

      if (this.recordsPreProceso.length == 0) {
        this.alertWarning(
          'No hay registros para agregar. Por favor, verifique'
        );
        return;
      }

      this.loading = true;

      try {
        await http.post(
          '/fileprocessing/altaLoteProcesoDebitos',
          JSON.stringify({
            listaDetalle: this.recordsPreProceso,
            empresaId: this.empresaId,
            formatoEnvioId: this.formatoEnvioId,
            cajaId: this.cajaId,
            fileName: this.archivosASubir.name,
          })
        );

        this.recordsPreProceso = [];
        this.alertSuccess('Se agregó el archivo a Lotes a Procesar.');

        // recargo los lotes a procesar (para la empresa que se acaba de usar)
        this.empresaLoteAProcesarId = this.empresaId;
        await this.loadLotesAProcesar();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async deleteLote(item) {
      if (confirm('¿Confirma la eliminación del Lote?')) {
        try {
          var result = await http.delete(
            'archivosDebito/deletelogproceso?logId=' + item.id
          );
          this.alertSuccess('El lote ha sido eliminado.');
          this.loadLotesAProcesar();
        } catch (error) {
          //Error
          Vue.$log.error(error);
          if (
            error.includes(
              'The DELETE statement conflicted with the REFERENCE constraint'
            )
          ) {
            this.alertError(
              'El Lote no puede ser eliminado debido a que está asociado a otras entidades.'
            );
          } else {
            this.alertError(error);
          }
        }
      }
    },
    async pasarLoteACompletado(item) {
      if (confirm('¿Confirma pasar el Lote como Completado?')) {
        try {
          var result = await http.post(
            'archivosDebito/marcarLoteComoCompletado',
            {logId: item.id}
          );
          this.alertSuccess('El lote ha sido marcado como Completado.');
          this.loadLotesAProcesar();
        } catch (error) {
          //Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async anularLote(item) {
      if (confirm('¿Confirma la ANULACIÓN del Lote?')) {
        try {
          this.loading = true;

          var result = await http.post(
            'archivosDebito/anularlogproceso',
            JSON.stringify({
              logId: item.id,
              motivo: 'Desimputación',
            })
          );

          this.alertSuccess('El proceso del lote ha sido anulado.');
          this.loadLotesAProcesar();
        } catch (error) {
          //Error
          Vue.$log.error(error);
          if (
            error.includes(
              'The DELETE statement conflicted with the REFERENCE constraint'
            )
          ) {
            this.alertError(
              'El Lote no puede ser eliminado debido a que está asociado a otras entidades.'
            );
          } else {
            this.alertError(error);
          }
        }

        this.loading = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async imprimirRespaldatorio(item) {
      let params = [];
      params.push({
        Version: this.$store.state.version, // version
        LoteProcesoId: item.id,
        ImputacionPendiente: false,
      });

      await this.setReporteActivo({
        reporte: 'Respaldatorio Impactos Positivos.trdp',
        params: params,
      });
      var ret = await window.open('/report-viewer');
      if (ret == null) {
        this.alertError(
          'Atención, no pudo abrise una nueva ventana con el Reporte. Es probable que el navegador esté bloqueando las ventanas emergentes. Verifique'
        );
      }

      await this.setReporteActivo({
        reporte: 'Respaldatorio Impactos Rechazados.trdp',
        params: params,
      });
      ret = await window.open('/report-viewer');
      if (ret == null) {
        this.alertError(
          'Atención, no pudo abrise una nueva ventana con el Reporte. Es probable que el navegador esté bloqueando las ventanas emergentes. Verifique'
        );
      }

      params = [];
      params.push({
        Version: this.$store.state.version, // version
        LoteProcesoId: item.id,
        ImputacionPendiente: true,
      });

      await this.setReporteActivo({
        reporte: 'Respaldatorio Impactos Positivos.trdp',
        params: params,
      });
      var ret = await window.open('/report-viewer');
      if (ret == null) {
        this.alertError(
          'Atención, no pudo abrise una nueva ventana con el Reporte. Es probable que el navegador esté bloqueando las ventanas emergentes. Verifique'
        );
      }
    },
    async procesarLotes(item) {
      if (this.recordsAProcesar.length == 0) {
        this.alertError('No hay lotes a procesar.');
        return;
      }

      var msg = '';
      if (item || this.recordsAProcesar.length == 1) {
        msg = '¿Confirma el Proceso del Lote seleccionado?';
      } else {
        msg =
          '¿Confirma el Proceso de los ' +
          this.recordsAProcesar.length +
          ' Lotes?';
      }

      if (confirm(msg)) {
        this.lotesAProcesar = [];
        this.lotesProcesados = [];

        if (item) {
          item.statusProceso = 0;
          this.lotesAProcesar.push(item);
        } else {
          for (let index = 0; index < this.recordsAProcesar.length; index++) {
            this.recordsAProcesar[index].statusProceso = 0;

            this.lotesAProcesar.push(this.recordsAProcesar[index]);
          }
        }

        this.showProcesoProgress = true;

        for (let index = 0; index < this.lotesAProcesar.length; index++) {
          this.loteProcesoActual = this.lotesAProcesar[index];

          this.loteProcesoActual.statusProceso = -1;
          this.loteProcesoActual.mensaje =
            '(este proceso puede demorar varios minutos)';

          try {
            await http.post(
              'archivosDebito/procesarlotedebitos',
              JSON.stringify({
                logId: this.loteProcesoActual.id,
                enviarSmsRechazo: this.enviarSmsRechazo,
                enviarSmsDebito: this.enviarSmsDebito,
                solicitarAutorizacionAfip: this.solicitarAutorizacionAfip,
                generarContacto: this.generarContacto,
                modeloSmsRechazoId: this.modeloSMSRechazoId,
                modeloSmsDebitoId: this.modeloSMSDebitoId,
              })
            );

            this.loteProcesoActual.statusProceso = 1;
            this.loteProcesoActual.mensaje = '';
          } catch (error) {
            console.log(error);

            this.loteProcesoActual.statusProceso = 2;
            this.loteProcesoActual.mensaje = 'ERROR: ' + error;
          }
          this.loteProcesoActual = null;
          this.lotesProcesados.push(this.lotesAProcesar[index]);
        }
      }

      this.loadLotesAProcesar();
    },
    async verLote(lote) {
    },
    async dividirArchivo() {
      this.loading = true;

      try {
        const formData = new FormData();
        formData.append('empresaId', this.empresaId);
        formData.append('formatoEnvioId', this.formatoEnvioId);
        formData.append('files', this.archivosASubir);

        const res = await http.post(
          '/fileprocessing/dividirArchivoDebitos',
          formData
        );

        const data = res.result || res;

        let cantidadDescargas = 0;

        if (data.casosArgen && data.casosArgen.length > 0) {
          const contenidoArgen = this.generarContenidoArchivo(
            data.header,
            data.subHeader,
            data.casosArgen,
            data.end
          );

          this.descargarTxt(
            `casos_argen_${data.prefijoArchivo}.txt`,
            contenidoArgen
          );

          cantidadDescargas++;
        }

        if (data.casosFinadi && data.casosFinadi.length > 0) {
          const contenidoFinadi = this.generarContenidoArchivo(
            data.header,
            data.subHeader,
            data.casosFinadi,
            data.end
          );

          this.descargarTxt(
            `casos_finadi_${data.prefijoArchivo}.txt`,
            contenidoFinadi
          );

          cantidadDescargas++;
        }

        if (data.casosDudosos && data.casosDudosos.length > 0) {
          const contenidoDudosos = this.generarContenidoArchivo(
            data.header,
            data.subHeader,
            data.casosDudosos,
            data.end
          );

          this.descargarTxt(
            `casos_dudosos_${data.prefijoArchivo}.txt`,
            contenidoDudosos
          );

          cantidadDescargas++;
        }

        if (cantidadDescargas === 0) {
          this.alertWarning('No se encontraron casos para descargar.');
          return;
        }

        this.alertSuccess('Archivo dividido correctamente.');
      } catch (error) {
        this.alertError(error);
      } finally {
        this.loading = false;
      }
    },
    async preProcesarArchivo() {
      var mensaje = '';
      if (this.generadoEnSmart)
        mensaje = '¿Confirma que el archivo fue Generado en Smart';
      if (this.soloPunitorios)
        mensaje = mensaje + ' y que se generó sólo con Punitorios';

      if (mensaje != '') {
        const res = await this.$dialog.confirm({
          text: mensaje + '?',
          title: 'Proceso de Imputación de Débito Generado en Smart',
          persistent: true, // Parece que no funciona...
        });

        if (!res) return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append('empresaId', this.empresaId);
      formData.append('formatoEnvioId', this.formatoEnvioId);
      formData.append('cajaId', this.cajaId);
      formData.append('files', this.archivosASubir);
      formData.append('soloPunitorios', this.soloPunitorios);
      formData.append('generadoEnSmart', this.generadoEnSmart);

      try {
        var res = await http.post(
          '/fileprocessing/preProcesarArchivoDebitos',
          formData
        );

        this.recordsPreProceso = res.list;

        if (res.totalCount == 0) {
          this.alertError(
            'No se pudo procesar el archivo con el formato seleccionado. Verifique si es correcto y en caso afirmativo consulte con Sistemas.'
          );
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async agregarCobranzasCardcred() {
      if (!this.cajaId || this.cajaId == 0) {
        this.alertWarning(
          'Por favor, seleccione la caja en donde imputar los pagos.'
        );
        return;
      }

      var registrosAEnviar = this.recordsStatusLote.filter((x) => x.procesar);
      if (registrosAEnviar.length == 0) {
        this.alertWarning(
          'No hay registros para agregar que no hayan sido procesados.'
        );
        return;
      }

      this.loading = true;

      const formData = {
        empresaId: this.empresaId,
        cajaId: this.cajaId,
        listaCobranzas: this.recordsStatusLote,
      };

      try {
        await http.post(
          '/archivosDebito/preprocesarpagoscardcred',
          JSON.stringify(formData)
        );

        this.alertSuccess('Se agregó el lote  a procesar.');
        this.recordsStatusLote = [];
        this.showCobranzasCardcred = false;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadLotesAProcesar() {
      this.loading = true;
      try {
        var result = await http.get(
          'archivosDebito/listlogprocesos?empresaId=' +
            this.empresaLoteAProcesarId +
            '&formatoArchivoId=&soloSinProcesar=true&limit=' +
            this.paginationAProcesar.itemsPerPage +
            '&page=' +
            this.paginationAProcesar.page +
            '&sortby=' +
            this.paginationAProcesar.sortBy +
            '&descending=' +
            (this.paginationAProcesar.sortDesc.length > 0
              ? this.paginationAProcesar.sortDesc
              : 'false')
        );

        this.recordsAProcesar = result.list;

        for (let index = 0; index < this.recordsAProcesar.length; index++) {
          const element = this.recordsAProcesar[index];
          element.statusProceso = 0;
          element.mensaje = '';
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    // async loadHistorialLotes() {
    //     this.loadingLog = true
    //     try {
    //         var result = await http.get('archivosDebito/listlogprocesos?empresaId=' + this.empresaLoteAProcesarId + '&formatoArchivoId=0&soloSinProcesar=false&limit='+this.optionsLog.itemsPerPage+'&page='+this.optionsLog.page+
    //                     '&sortby='+this.optionsLog.sortBy+'&descending='+(this.optionsLog.sortDesc.length > 0 ? this.optionsLog.sortDesc : 'false'));

    //         this.recordsLog = result.list;
    //         this.totalItemsLog = result.totalCount;
    //     } catch (error) {
    //         // Error
    //         this.alertError(error)
    //     }
    //     this.loadingLog = false
    // },
    async loadHistorialLotes() {
      this.loadingLog = true;

      try {
        var result = await http.get(
          'archivosDebito/listlogprocesos?empresaId=' +
            this.empresaLoteAProcesarId +
            '&formatoId=' +
            this.formatoId +
            '&soloSinProcesar=false' +
            '&fechaDesde=' +
            this.periodoLote.desde +
            '&fechaHasta=' +
            this.periodoLote.hasta +
            '&limit=' +
            this.optionsLog.itemsPerPage +
            ' &page=' +
            this.optionsLog.page +
            '&sortby=' +
            this.optionsLog.sortBy +
            '&descending=' +
            (this.optionsLog.sortDesc.length > 0
              ? this.optionsLog.sortDesc
              : 'false')
        );

        console.log(result.list);
        this.recordsLog = result.list;
        this.totalItemsLog = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingLog = false;
    },

    async loadLotesCardCred() {
      this.loadingLog = true;
      try {
        var result = await http.get(
          'external/listarlotescardcredenviados?limit=' +
            this.optionsLog.itemsPerPage +
            '&page=' +
            this.optionsLog.page +
            '&sortby=' +
            this.optionsLog.sortBy +
            '&descending=' +
            (this.optionsLog.sortDesc.length > 0
              ? this.optionsLog.sortDesc
              : 'false')
        );

        this.recordsLotesCardCred = result.list;
        this.totalItemsLotesCardCred = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingLog = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get('empresas'); // traigo todas
        this.empresas = result.list;
        console.log(this.empresas);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCajas() {
      this.loading = true;
      try {
        var result = await http.get(
          'cajas/disponiblesporusuario?login=' + this.user.login
        );
        this.cajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadBancos() {
      this.loading = true;
      //   try{
      //     var result = await http.get('bancos/');

      //     this.productos = result.list;

      //     this.productos.unshift({id:0,descripcion:'(Todos)'});
      //   }
      //   catch(error){
      //     // Error
      //     this.alertError(error)
      //   }
      this.loading = false;
    },
    async loadFormatosEnvio() {
      this.loading = true;
      try {
        var result = await http.get('archivosDebito/formatosenvio'); // traigo todos

        this.formatosEnvio = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormatoEnvio() {
      this.loading = true;
      try {
        var result = await http.get('archivosDebito/formatosenvio'); // traigo todos

        this.formatoEnvio = result.list;

        this.formatoEnvio.unshift({ id: 0, descripcion: '(Todos)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadModelosSMS() {
      this.loading = true;
      try {
        var result = await http.get('modelossms');

        this.listModelosSMS = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async verDetalleLoteCardCred(loteId) {
      this.loadingStatusLote = true;
      try {
        var result = await http.get(
          'external/getstatuslotecardcred?loteId=' +
            loteId +
            '&empresaId=' +
            this.empresaId
        ); // traigo todos
        console.log(result);

        this.recordsStatusLote = result.list;
        this.totalItemsStatusLote = result.totalCount;
        this.showStatusLoteCardcred = true;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingStatusLote = false;
    },
    async buscarPagosCardcred() {
      this.loadingStatusLote = true;
      try {
        var result = await http.get(
          'external/getcobranzasentrefechas?fechaDesde=' +
            this.periodoPagosCardcred.desde +
            '&fechaHasta=' +
            this.periodoPagosCardcred.hasta +
            '&empresaId=' +
            this.empresaId +
            '&documento=' +
            this.filtroCardCredDocumento
        ); // traigo todos
        console.log(result);

        this.recordsStatusLote = result.list;
        this.totalItemsStatusLote = result.totalCount;
        this.showCobranzasCardcred = true;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingStatusLote = false;
    },
    generarContenidoArchivo(header, subHeader, detalles, end) {
      const lineas = [];

      if (header) lineas.push(header);
      if (subHeader) lineas.push(subHeader);
      if (detalles && detalles.length > 0) lineas.push(...detalles);
      if (end) lineas.push(end);

      return lineas.join('\r\n');
    },
    descargarTxt(nombreArchivo, contenido) {
      const encoder = new TextEncoder();
      const byteArray = encoder.encode(contenido);

      this.saveByteArray(
        nombreArchivo,
        byteArray,
        'text/plain;charset=utf-8'
      );
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], {type: dataType});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();      
    },
  },
};
</script>
